var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_325_125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 -0.271973H0V31.728H32V-0.271973Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_325_125)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5125 30.1002C24.9419 30.4042 25.4952 30.4802 25.9885 30.2935C26.4819 30.1055 26.8445 29.6842 26.9539 29.1735C28.1125 23.7282 30.9232 9.94551 31.9779 4.99222C32.0579 4.61889 31.9245 4.23089 31.6312 3.98155C31.3379 3.73222 30.9312 3.66022 30.5685 3.79489C24.9779 5.86422 7.76053 12.3242 0.723197 14.9282C0.27653 15.0935 -0.0141362 15.5229 0.000530473 15.9935C0.0165305 16.4655 0.333864 16.8749 0.791197 17.0122C3.9472 17.9562 8.08986 19.2695 8.08986 19.2695C8.08986 19.2695 10.0259 25.1162 11.0352 28.0895C11.1619 28.4629 11.4539 28.7562 11.8392 28.8575C12.2232 28.9575 12.6339 28.8522 12.9205 28.5815C14.5419 27.0509 17.0485 24.6842 17.0485 24.6842C17.0485 24.6842 21.8112 28.1762 24.5125 30.1002ZM9.83253 18.5309L12.0712 25.9149L12.5685 21.2389C12.5685 21.2389 21.2179 13.4375 26.1485 8.99089C26.2925 8.86022 26.3125 8.64155 26.1925 8.48822C26.0739 8.33489 25.8552 8.29889 25.6912 8.40289C19.9765 12.0522 9.83253 18.5309 9.83253 18.5309Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.7369da3f0975c7bf54263118518f84e2.svg";
export { ForwardRef as ReactComponent };